import Vue from 'vue';
import VueI18n from "vue-i18n";
Vue.use(VueI18n);

import en from './en.json';
import de from './de.json';

const i18n = new VueI18n({
	locale: localStorage.getItem('locale') || 'en',
	messages:{
		en,
		de
	}
});

export default i18n;